import { render, staticRenderFns } from "./FunnelStudioBreadcrumb.vue?vue&type=template&id=37bda0a0&scoped=true"
import script from "./FunnelStudioBreadcrumb.vue?vue&type=script&lang=js"
export * from "./FunnelStudioBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./FunnelStudioBreadcrumb.vue?vue&type=style&index=0&id=37bda0a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bda0a0",
  null
  
)

export default component.exports